<div class="logo">
  <a routerLink="/dashboard" class="simple-text logo-mini" [matTooltip]="appName | uppercase" matTooltipPosition="right">
    <div class="sidebar-mark">
      <img src="assets/svg/logo-mppre-mark.svg" alt="MPPRE" class="sidebar-mark-logo">
    </div>
  </a>
  <a routerLink="/dashboard" class="simple-text logo-normal">
    <span class="sidebar-brand-name">Cancillería</span>
    <span class="sidebar-brand-sub">Digital</span>
  </a>
</div>
<div class="sidebar-wrapper">
  <p class="nav-section-label">Navegación</p>
  <ul class="nav">
    <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item">
      <!--If is a single link-->
      <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link' && auth.hasAccess(menuitem.ability) && auth.hasAccessByCondition(menuitem.conditions)" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p matTooltip="{{menuitem.title}}" [matTooltipPosition]="'right'">{{menuitem.title | truncate}}</p>
      </a>
      <!--If it have a submenu-->
      <a data-toggle="collapse" href="#{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub' && auth.hasAccess(menuitem.ability) && auth.hasAccessByCondition(menuitem.conditions)" (click)="updatePS()" class="nav-link">
        <i class="material-icons">{{menuitem.icontype}}</i>
        <p matTooltip="{{menuitem.title}}" [matTooltipPosition]="'right'">{{menuitem.title | truncate}}<b class="caret"></b></p>
      </a>
      <!--Display the submenu items-->
      <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
        <ul class="nav">
          <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
            <a [routerLink]="[menuitem.path, childitem.path]" class="nav-link" *ngIf="auth.hasAccess(childitem.ability) && auth.hasAccessByCondition(childitem.conditions)" matTooltip="{{childitem.title}}" [matTooltipPosition]="'right'">
              <span class="sidebar-mini">{{childitem.ab}}</span>
              <span class="sidebar-normal">{{childitem.title | truncate}}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
  <ng-container *ngIf="user?.nationalityType?.code === 'E'">
    <p class="nav-section-label">Recursos</p>
    <ul class="nav">
      <li class="nav-item">
        <a href="https://mppre.gob.ve/cancilleria-digital"
           target="_blank"
           rel="noopener noreferrer"
           class="nav-link">
          <i class="material-icons">description</i>
          <p matTooltip="Planilla de solicitud de visa" [matTooltipPosition]="'right'">Planilla de solicitud de visa</p>
        </a>
      </li>
    </ul>
  </ng-container>
</div>
<div class="sidebar-footer">
  <a href="javascript:void(0)" class="nav-link" (click)="logOut($event)">
    <i class="material-icons">logout</i>
    <span class="sidebar-footer-text">Cerrar sesión</span>
  </a>
</div>
